class ExponeaReco extends HTMLElement {
  connectedCallback() {
    // Read attributes
    const recommendation_id = this.getAttribute('recommendation-id');
    const productsToShow = this.getAttribute('products-to-show') || 10;

    // Find target container
    const container_for_products = this.querySelector('.js-container-for-products');

    // State
    let RCM_STATUS = 0;
    // Load recommendations data from exponea
    const loadRecommendations = () => {
      // Recommendations configuration
      const options = {
        recommendationId: recommendation_id,
        size: Number(productsToShow),
        fields: ['ITEM_GROUP_ID', 'HANDLE'],
        callback: onRecommendationsLoaded,
        fillWithRandom: true,
        catalogFilter: [],
        catalogAttributesWhitelist: [],
      };

      // Call recommendations
      if (window.exponea && typeof window.exponea.getRecommendation === 'function') {
        window.exponea.getRecommendation(options);
      }

      // Timeout logic
      this._timeout = setTimeout(() => {
        if (RCM_STATUS !== 'LOADED') {
          RCM_STATUS = 'TIMED_OUT';
          if (window.exponea && typeof window.exponea.track === 'function') {
            window.exponea.track('recommendation', {
              action: 'timeout',
              recommendation_id: recommendation_id,
              // other required properties: placement, ...
            });
          }
        }
      }, 5000);
    };

    // Observer to trigger loading recommendations when near viewport
    if (!this._preloadObserver) {
      this._preloadObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry && entry.isIntersecting) {
            loadRecommendations();
            this._preloadObserver.disconnect();
            this._preloadObserver = null;
          }
        },
        { rootMargin: '200px' }
      );
      this._preloadObserver.observe(this);
    }

    // Render items when loaded from exponea
    const onRecommendationsLoaded = (data) => {
      console.log('Recommendations loaded:', data);
      if (RCM_STATUS !== 'TIMED_OUT') {
        RCM_STATUS = 'LOADED';

        if (data && data.length > 0) {
          const handles = data.map(function (item) {
            return encodeURIComponent(item.HANDLE);
          });
          const itemIds = data.map(function (item) {
            return item.ITEM_GROUP_ID;
          });

          fetch('/collections/all?type=' + handles.join('+') + '&view=list-products', {
            method: 'GET',
          })
            .then((response) => response.text())
            .then((htmlText) => {
              const parser = new DOMParser();
              const parsedHTML = parser.parseFromString(htmlText, 'text/html');
              const parsedElements = parsedHTML.querySelectorAll('.slider__slide');

              const fragment = document.createDocumentFragment();
              parsedElements.forEach((element, index) => {
                element.setAttribute('id', `Slide-prlist-${index + 1}`);
                fragment.appendChild(element.cloneNode(true));
              });
              if (container_for_products) {
                // Show the section (remove hidden)
                // this.classList.remove('hidden');
                container_for_products.innerHTML = '';
                container_for_products.appendChild(fragment);
              }
            })
            .catch((error) => {
              console.log('Fetch error:', error);
            });

          // Track event recommendation action=show only when visible
          if (!this._showObserver && itemIds && itemIds.length) {
            this._showObserver = new IntersectionObserver(
              ([entry]) => {
                if (entry && entry.isIntersecting) {
                  if (window.exponea && typeof window.exponea.track === 'function') {
                    window.exponea.track('recommendation', {
                      action: 'show',
                      item_ids: itemIds,
                      recommendation_id: recommendation_id,
                      // other properties: placement, ...
                    });
                  }
                  this._showObserver.disconnect();
                  this._showObserver = null;
                }
              },
              { threshold: 0.1 }
            );
            this._showObserver.observe(this);
          }
        } else {
          console.warn('No recommendations found for this placement.');
        }
      } else {
        console.warn('Recommendations timed out (5000ms).');
      }
    };
  }

  disconnectedCallback() {
    // Clean up listeners, timers, etc.
    if (this._timeout) {
      clearTimeout(this._timeout);
    }
    if (this._showObserver) {
      this._showObserver.disconnect();
      this._showObserver = null;
    }
    if (this._preloadObserver) {
      this._preloadObserver.disconnect();
      this._preloadObserver = null;
    }
  }
}

customElements.define('exponea-reco', ExponeaReco);
